import { PARAM_CHANGE } from '@store/actions';
import BLOCKS from '@store/blocks';

export function SHIFT_STEP(store, number) {
  PARAM_CHANGE(
    store,
    BLOCKS.RECON_PANELS.CURRENT_STEP,
    store.get(BLOCKS.RECON_PANELS.CURRENT_STEP) + number,
  );
}

export function BEGIN_RECON(store) {
  PARAM_CHANGE(store, BLOCKS.MINI_MAP.WITH_TREES, true);
  PARAM_CHANGE(store, BLOCKS.MINI_MAP.WITH_LEGENDS, false);
  PARAM_CHANGE(store, BLOCKS.MINI_MAP.ZOOM, 1);
  PARAM_CHANGE(store, BLOCKS.MAP.OFFSET, { x: 0, y: 0 });
}
